# CSS files
require('babel-polyfill')

require('scss/zenclerk/mvp-ready/mvpready-admin.css')
require('scss/zenclerk/mvp-ready/mvpready-flat.css')
require('scss/zenclerk/mvp-ready/custom.css.scss')

require('scss/zenclerk/module/config.scss')
require('scss/zenclerk/module/list.scss')
require('scss/zenclerk/module/notice.scss')
require('scss/zenclerk/module/incentive.scss')
require('scss/zenclerk/module/button.scss')
require('scss/zenclerk/module/alert.scss')
require('scss/zenclerk/module/error-page.scss')
require('scss/zenclerk/module/setcode.scss')
require('scss/zenclerk/module/button_new.scss')
require('scss/zenclerk/module/notification.scss')

require('scss/zenclerk/common.scss')
require('scss/main.scss')

# Initialize the required modules first
require('shared_modules/core/index.js.coffee')
require('shared_modules/common_api/index.coffee')
require('zenclerk_modules/users/index.js.coffee')
require('zenclerk_modules/users.pages/index.js.coffee')
require('zenclerk_modules/projects/index.js.coffee')
require('zenclerk_modules/projects.campaigns/index.js.coffee')
require('zenclerk_modules/projects.reports/index.js.coffee')
require('zenclerk_modules/projects.heatmap/zc.projects.heatmap.module.js')
require('zenclerk_modules/agencies/zc.agencies.module.js')

window.ZC_CONFIG = require('env')

require('bootstrap/dist/js/bootstrap.js')

Sentry = require('@sentry/browser')
{ Integrations } = require('@sentry/tracing')
{ Angular: AngularIntegration } = require('@sentry/integrations')

enableSentry = !['development', 'test'].includes(window.ZC_CONFIG.ENV)
if enableSentry
  Sentry.init {
    dsn: window.ZC_CONFIG.SENTRY_DSN,
    integrations: [
      new AngularIntegration(),
      new Integrations.BrowserTracing({
        tracingOrigins: [
          'localhost',
          'aideal.appier.com',
          'aideal-pre.appier.com',
          'enterprise-stg.aideal.arepa.appier.co'],
      })]
    tracesSampleRate: 0.01,
    sendClientReports: false,
    environment: window.ZC_CONFIG.ENV,
  }


app = angular.module 'zc', [
  'ui.router'
  'ngResource'
  'ngAnimate'
  'ngMessages'
  'ngCsv'
  'ngCookies'
  'pascalprecht.translate'
  'LocalStorageModule'
  'ui.bootstrap'
  'ui.bootstrap.dropdown'
  'xeditable'
  'zc.core'
  'zc.commonApi'
  'zc.users'
  'zc.users.pages'
  'zc.agencies'
  'zc.projects'
  'zc.projects.campaigns'
  'zc.projects.reports'
  'zc.projects.heatmap'
  'colorpicker.module'
  'ngclipboard'
  'hljs'
  'ui.bootstrap.datetimepicker'
  'angular-md5'
  'rzModule'
  'ngSentry'
]

# coffee
moduleReq = require.context('shared_modules', true, /^\.\/.*/)
for key in moduleReq.keys()
  unless key.match(/\.test(\.js|\.coffee)?$/)
    moduleReq(key)

moduleReq = require.context('zenclerk_modules', true, /^\.\/.*/)
for key in moduleReq.keys()
  unless key.match(/\.test(\.js|\.coffee)?$/)
    moduleReq(key)

# define these here, because they are application specific
# TODO: move into some file
app.config ($stateProvider) ->
  $stateProvider
  .state '404',
    url: '/404'
    views:
      'header@':
        templateUrl: '/templates/users/views/devise_header.html'
      'content@':
        templateUrl: '/templates/core/views/404.html'

  .state '500',
    url: '/500'
    views:
      'header@':
        templateUrl: '/templates/users/views/devise_header.html'
      'content@':
        templateUrl: '/templates/core/views/500.html'
  .state 'terms_of_service',
    url: '/admin/tos'
    controller: 'TosController',
    controllerAs: 'vm'
    views:
      'header@':
        templateUrl: '/templates/core/views/tos_header.html'
        controller: 'TosHeaderController'
        controllerAs: 'vm'
        resolve:
          languages: () ->
            [
              {
                id: 'en',
                label: 'English',
              },
              {
                id: 'ja',
                label: '日本語',
              },
              {
                id: 'zh',
                label: '中文',
              },
            ]

      'content@':
        templateUrl: '/templates/core/views/tos.html'
        controller: 'TosController'
        controllerAs: 'vm'
  .state 'privacy_policy',
    url: '/admin/privacy_policy'
    views:
      'header@':
        templateUrl: '/templates/users/views/devise_header.html'
      'content@':
        templateUrl: '/templates/core/views/privacy_policy.html'
        controller: 'PrivacyPolicyCtrl'

# These weren't necessary in zenclerk S so removed from core.
# Test thoroughly before removing from zenclerk

# disable automatic scrolling to where ui-view changed
app.value('$anchorScroll', angular.noop)
# Avoid screen move when page transition
app.config ($uiViewScrollProvider) ->
  $uiViewScrollProvider.useAnchorScroll()

app.service "afterLoginHandler", ($location, $state, $cookies, $translate, Project, Environment, returnUrl) ->
  class AfterLoginHandler
    @handle: (currentUser) ->
      return if !currentUser
      Environment.get()
      .then (env) =>
        $cookies.put('__zc_admin', "user_id=#{currentUser.id}", { path: '/', expires: moment().add(1, 'years').toDate(), secure: (env in ['production', 'preprod', 'staging']) })

      # set lang
      $translate.use(currentUser.lang)
      moment.locale(currentUser.lang)

      if returnUrl.get()
        $location.url(returnUrl.get())
        returnUrl.set(null)
        return

      $state.go 'admin.home'

app.run ($rootScope, $state, $window, Devise, Page, Project, ZcTag, afterLoginHandler, lib) ->
  $rootScope.Page = Page

  ZcTag.initialize()

  $rootScope.$on '$stateChangeStart', (event, toState, toParams) ->
    return if !toState
    return if toState.name is 'users.invitation.accept'
    return if toState.name is 'users.invitation.complete'
    return if toState.name is 'users.password.reset'
    return if toState.name is 'privacy_policy'
    return if toState.name is 'terms_of_service'

    # TODO: REFACTOR this logic is WAY TOO COMPLICATED AND WITHOUT TESTS
    Devise.getCurrentUser()
    .then (user) ->
      return if !user

      $window.document.documentElement.lang = user.lang

      if user && toState.name is 'users.signIn'
        event.preventDefault() # To avoid redirect loops
        return afterLoginHandler.handle(user)

      if toState.name == 'admin.pricing'
        # pass
        return

      lib.setHighChartOptions()

      # If user is trying to access anything under projects (except under
      # projects/xxx/installation), but installation tasks are still not
      # complete, he will be forwarded to installation.
      if !Devise.isMaster() and
          (toState.name?.indexOf?('admin.projects.') == 0 and
          toState.name?.indexOf?('admin.projects.settings') != 0 and
          typeof toParams.projectId != "undefined")
        # use toParams.projectId to check the tasks for correct project
        projectId = toParams.projectId
        Project.get(projectId).then (project) ->
          return if project.tracking_tag_confirmed_at and
                    (project.is_wevnal or project.conversion_tag_confirmed_at)
          event.preventDefault() # To avoid redirect loops
          $state.go 'admin.projects.settings.installation', { projectId: projectId }


  $rootScope.$on '$stateChangeError', (event, toState, toStateParams, fromState, fromStateParams, errors) ->
    console.log "Error changing state", errors, "FROM", fromState, "TO", toState, toStateParams
    if !Devise.currentUser
      $state.go 'users.signIn'



// WEBPACK FOOTER //
// ./src/zenclerk_app.coffee